import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { topics, testimonials } from '@/mocks/site';
import SectionHeading from '@/components/base/SectionHeading';

const Spotlight = () => {
  const feature = articles.find((item) => item.id === 'a-1006') ?? articles[5];
  const sideList = articles.filter((item) => item.topicSlug === 'backstage' && item.id !== feature.id).slice(0, 2);

  return (
    <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16" aria-labelledby="spotlight-heading">
      <SectionHeading
        eyebrow="本周专题"
        title="幕后资本观察"
        desc="把娱乐新闻放回商业结构里看，很多让人费解的决策其实都有清晰的账本逻辑。"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.4fr_1fr]">
        <article className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-100/50">
          <Link to={`/article/${feature.id}`} className="block h-56 w-full overflow-hidden md:h-80">
            <img
              src={feature.cover}
              alt={`${feature.title} - 幕后资本专题`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
          </Link>
          <div className="p-5 md:p-7">
            <span className="rounded-full bg-accent-100 px-3 py-1 text-[11px] text-accent-900">
              {feature.topicName}
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              <Link to={`/article/${feature.id}`} className="hover:text-primary-600">
                {feature.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{feature.excerpt}</p>
            <Link
              to={`/article/${feature.id}`}
              className="mt-5 inline-flex whitespace-nowrap items-center gap-1.5 rounded-full bg-foreground-950 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-foreground-800"
            >
              阅读完整爆料
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </article>

        <div className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950">专题延伸阅读</h3>
            <ul className="mt-4 space-y-4">
              {sideList.map((item) => (
                <li key={item.id} className="flex gap-3">
                  <Link
                    to={`/article/${item.id}`}
                    className="h-16 w-20 shrink-0 overflow-hidden rounded-md"
                  >
                    <img
                      src={item.cover}
                      alt={`${item.title} - 看瓜爆料`}
                      className="h-full w-full object-cover object-top"
                    />
                  </Link>
                  <div className="min-w-0">
                    <Link
                      to={`/article/${item.id}`}
                      className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 hover:text-primary-600"
                    >
                      {item.title}
                    </Link>
                    <p className="mt-1 text-[11px] text-foreground-500">{item.dateLabel} · {item.readTime}</p>
                  </div>
                </li>
              ))}
              {topics.slice(0, 3).map((topic) => (
                <li key={topic.slug} className="flex items-center gap-2">
                  <i className={`${topic.icon} text-base text-secondary-600`}></i>
                  <Link
                    to={`/topic/${topic.slug}`}
                    className="text-sm text-foreground-700 hover:text-primary-600"
                  >
                    {topic.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <figure className="rounded-lg border border-background-200/70 bg-secondary-50 p-5 md:p-6">
            <i className="ri-double-quotes-l text-2xl text-secondary-500"></i>
            <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
              {testimonials[0].content}
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-sm font-bold text-secondary-900">
                {testimonials[0].name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-950">{testimonials[0].name}</span>
                <span className="block text-xs text-foreground-500">{testimonials[0].role}</span>
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Spotlight;